const TRACKING_SOURCES = ['direct', 'poster_qr', 'invite_link', 'recall_sms'];

const LEGACY_SOURCE_MAP = {
  sms_share: 'recall_sms',
  team_share: 'poster_qr',
  direct: 'direct'
};

const QUALIFICATION_INVALID_CODES = [-10151, -10153, -10402, -10435, -20108];

function normalizeCode(error) {
  const code = error && error.serviceResponse ? error.serviceResponse.code : undefined;
  return Number(code);
}

/**
 * Reads the controlled tracking fields from the current HashRouter query.
 * Explicit source wins; legacy entry_source is mapped, and req_id reuses from_team_id.
 * @param {object} history React Router history containing location.search.
 * @returns {{source:string,reqId:string,shareCode:string}} Tracker-ready attribution fields.
 */
export function resolveTrackerContext(history) {
  const search = history && history.location && typeof history.location.search === 'string' ? history.location.search : '';
  const params = new URLSearchParams(search.charAt(0) === '?' ? search.slice(1) : search);
  const explicitSource = params.get('source') || '';
  const legacySource = params.get('entry_source') || '';
  const source =
    TRACKING_SOURCES.indexOf(explicitSource) !== -1
      ? explicitSource
      : TRACKING_SOURCES.indexOf(legacySource) !== -1
        ? legacySource
        : LEGACY_SOURCE_MAP[legacySource] || 'direct';

  return {
    source,
    reqId: params.get('from_team_id') || '',
    shareCode: params.get('share_code') || ''
  };
}

/** Maps create_team service failures to the CSV status_reason enum. */
export function getCreateTeamFailureReason(error) {
  const code = normalizeCode(error);
  if (code === -20124) return 'team_exists';
  if ([-10154, -20109].indexOf(code) !== -1) return 'activity_ended';
  if (QUALIFICATION_INVALID_CODES.indexOf(code) !== -1) return 'qualification_invalid';
  return 'server_error';
}

/** Maps join_team service failures to the CSV status_reason enum. */
export function getJoinTeamFailureReason(error) {
  const code = normalizeCode(error);
  if (code === -20124) return 'already_in_team';
  if (code === -20126) return 'team_full';
  if (code === -20125) return 'team_invalid';
  if ([-10154, -20109].indexOf(code) !== -1) return 'activity_ended';
  if (QUALIFICATION_INVALID_CODES.indexOf(code) !== -1) return 'qualification_invalid';
  return 'server_error';
}

/** Maps claim_prize service failures to the CSV status_reason enum. */
export function getClaimRewardFailureReason(error) {
  const code = normalizeCode(error);
  if ([-20133, -20135].indexOf(code) !== -1) return 'not_eligible';
  if ([-10151, -10153, -10154, -20103, -20104].indexOf(code) !== -1) return 'not_open';
  if (code === -20122) return 'role_unbound';
  if (code === -20134) return 'already_claimed';
  return 'server_error';
}
